module.exports = __webpack_public_path__ + "img/picture_viptk03n.5875cf04.png";